<script setup>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { Mail, Lock } from 'lucide-vue-next';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';
import { Checkbox } from '@/Components/ui/checkbox';

defineProps({
    canResetPassword: Boolean,
    status: String,
});

const form = useForm({
    email: '',
    password: '',
    remember: false,
});

const submit = () => {
    form.transform(data => ({
        ...data,
        remember: form.remember ? 'on' : '',
    })).post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};
</script>

<template>
    <Head title="Đăng nhập" />

    <div class="flex min-h-screen items-center justify-center bg-muted px-4 py-12">
        <Card class="w-full max-w-md">
            <CardHeader class="space-y-2 text-center">
                <CardTitle class="text-3xl">
                    <span class="font-bold">Đông Tây</span> ERP
                </CardTitle>
                <CardDescription>Đăng nhập để tiếp tục</CardDescription>
            </CardHeader>

            <CardContent>
                <JetValidationErrors class="mb-4" />

                <div v-if="status" class="mb-4 text-center text-sm font-medium text-green-600">
                    {{ status }}
                </div>

                <form class="space-y-4" @submit.prevent="submit">
                    <div class="space-y-2">
                        <Label for="email">Email</Label>
                        <div class="relative">
                            <Mail class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input
                                id="email"
                                v-model="form.email"
                                type="email"
                                class="pl-10"
                                placeholder="email@dongtay.vn"
                                required
                                autofocus
                            />
                        </div>
                    </div>

                    <div class="space-y-2">
                        <Label for="password">Mật khẩu</Label>
                        <div class="relative">
                            <Lock class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input
                                id="password"
                                v-model="form.password"
                                type="password"
                                class="pl-10"
                                placeholder="••••••••"
                                required
                                autocomplete="current-password"
                            />
                        </div>
                    </div>

                    <div class="flex items-center gap-2">
                        <Checkbox id="remember" v-model:checked="form.remember" />
                        <Label for="remember" class="cursor-pointer text-muted-foreground">
                            Ghi nhớ đăng nhập
                        </Label>
                    </div>

                    <Button
                        type="submit"
                        class="w-full"
                        :class="{ 'opacity-50': form.processing }"
                        :disabled="form.processing"
                    >
                        Đăng nhập
                    </Button>
                </form>

                <div class="mt-6 flex items-center justify-between text-sm">
                    <Link
                        v-if="canResetPassword"
                        :href="route('password.request')"
                        class="text-muted-foreground hover:text-primary hover:underline"
                    >
                        Quên mật khẩu?
                    </Link>
                    <a href="/register" class="text-primary hover:underline">Đăng ký tài khoản</a>
                </div>
            </CardContent>
        </Card>
    </div>
</template>
